import { RequireAuth } from "@allergy123/auth-client/react";
import { createBrowserRouter, Outlet } from "react-router";
import { RepsShell } from "./shell";
import { AuthCallbackPage, NoAccessPage, SignedOutPage } from "./pages/auth";
import { HomePage } from "./pages/Home";
import { StatementsPage } from "./pages/Statements";
import { VolumePage } from "./pages/Volume";

/** Representative portal (ADR 0012). The API resolves the representative record; the browser only renders what it returns. */
export const router = createBrowserRouter([
  { path: "/auth/callback", Component: AuthCallbackPage },
  { path: "/auth/signed-out", Component: SignedOutPage },
  { path: "/no-access", Component: NoAccessPage },
  {
    path: "/",
    element: (
      <RequireAuth fallback={<p className="p-6 text-ink-secondary">Signing you in…</p>}>
        <RepsShell>
          <Outlet />
        </RepsShell>
      </RequireAuth>
    ),
    children: [
      { index: true, Component: HomePage },
      { path: "volume", Component: VolumePage },
      { path: "statements", Component: StatementsPage },
    ],
  },
]);
